export default __webpack_public_path__ + "static/media/money.da3121ff.svg";